import { useState } from "react";
import { useA11yNestedNavigation } from "../../../a11y";

export const useOptionsA11y = ({
  count,
  scrollToIndex,
}: {
  count: number;
  scrollToIndex: (index: number) => void;
}) => {
  const [hasA11yFocused, setHasA11yFocused] = useState(false);

  const { handleEnter, handleAfterBlur, ...restProps } =
    useA11yNestedNavigation({
      maxIndex: Math.max(0, count),
      hasFocusableChildren: true,
    });

  const scrollTop = () => {
    scrollToIndex(0);
  };

  const handleEnterKeyDown = () => {
    scrollTop();
    setHasA11yFocused(true);
    handleEnter();
  };

  const resetFocus = () => {
    scrollTop();
    setHasA11yFocused(false);
    handleAfterBlur();
  };

  return {
    hasA11yFocused,
    resetFocus,
    handleEnterKeyDown,
    ...restProps,
  };
};
